import { Card } from "../_shared/card";
import { IconFolder } from "../_shared/icons";
import { navigate } from "../_shared/router";
import { useDemo } from "../_shared/demo.provider";

export function DocumentsCard() {
  const { documents } = useDemo();
  const transmitted = documents.filter((d) => d.status === "received").length;
  const missing = documents.length - transmitted;
  const total = documents.length;

  return (
    <Card
      title="Documents"
      icon={<IconFolder width={18} height={18} />}
      onClick={() => navigate("documents")}
      titleSize="sm"
    >
      <div className="flex items-center gap-3">
        <DocumentsRing transmitted={transmitted} total={total} />
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-[var(--text-1)]">
            {transmitted} sur {total} transmis
          </p>
          {missing > 0 ? (
            <p className="mt-0.5 text-[12px] font-semibold text-[var(--sf-primary)]">
              {missing} manquant{missing > 1 ? "s" : ""}
            </p>
          ) : (
            <p className="mt-0.5 text-[12px] text-[var(--text-2)]">
              Tout est transmis
            </p>
          )}
        </div>
      </div>
    </Card>
  );
}

function DocumentsRing({
  transmitted,
  total,
}: {
  transmitted: number;
  total: number;
}) {
  const size = 56;
  const strokeWidth = 6;
  const radius = (size - strokeWidth) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = total > 0 ? transmitted / total : 0;
  const offset = circumference * (1 - Math.max(0, Math.min(1, progress)));

  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={cx}
          cy={cy}
          r={radius}
          strokeWidth={strokeWidth}
          fill="none"
          className="stroke-[var(--surface-3)]"
        />
        <circle
          cx={cx}
          cy={cy}
          r={radius}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="stroke-[var(--sf-primary)] transition-[stroke-dashoffset] duration-500"
        />
      </svg>
      <div className="absolute inset-0 flex items-baseline justify-center gap-0.5 pt-[18px]">
        <span className="text-[15px] font-extrabold leading-none text-[var(--text-1)]">
          {transmitted}
        </span>
        <span className="text-[10.5px] font-semibold text-[var(--text-3)]">
          /{total}
        </span>
      </div>
    </div>
  );
}
